export default __webpack_public_path__ + "static/media/KZ.df03abd9.svg";